import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  timeout: 30000,
});

// Attach JWT bearer from localStorage on every request
apiClient.interceptors.request.use((config) => {
  const token = typeof window !== "undefined" ? localStorage.getItem("nms_token") : null;
  if (token) {
    config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
  }
  return config;
});

// Auto-logout on 401
apiClient.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && typeof window !== "undefined") {
      const isLoginCall = err.config?.url?.includes("/auth/login");
      if (!isLoginCall) {
        localStorage.removeItem("nms_token");
        localStorage.removeItem("nms_user");
        // Hard redirect so AuthContext re-evaluates cleanly
        if (window.location.pathname !== "/login") window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const fetchDashboard = () => apiClient.get("/dashboard").then((r) => r.data);
export const fetchAiSummary = () => apiClient.get("/ai-summary").then((r) => r.data);
export const fetchAllIssues = () => apiClient.get("/issues").then((r) => r.data);
export const fetchIndicators = () => apiClient.get("/indicators").then((r) => r.data);
export const fetchKamtibmas = (year = 2026) =>
  apiClient.get(`/kamtibmas?year=${year}`).then((r) => r.data);
export const fetchRisiko = (region) =>
  apiClient.get(region ? `/risiko?region=${region}` : "/risiko").then((r) => r.data);
export const fetchRisikoHistory = (region, range = "30d") =>
  apiClient.get(`/risiko/history?region=${region}&range=${range}`).then((r) => r.data);
export const fetchCommodityV3 = (region = "") =>
  apiClient.get(`/commodity/v3?region=${region}`).then((r) => r.data);
export const fetchCommodityDetail = (code) =>
  apiClient.get(`/commodity/detail?code=${code}`).then((r) => r.data);
export const fetchCommodityHistory = (kind, code, timeframe = "1y") =>
  apiClient
    .get(`/commodity/national-regional/${kind}/${code}?timeframe=${timeframe}`)
    .then((r) => r.data);
